import React from 'react'

import { ClassificationResult, FileUploadState } from '@documents/types'
import { TwAlertTriangle } from '@frame/images/icons/tw-alert-triangle'
import { TwCircleCheck } from '@frame/images/icons/tw-circle-check'
import { TwQuestionMark } from '@frame/images/icons/tw-question-mark'

import { useDocumentCardContext } from '../../context'
import { Divider } from '../../divider'
import { Header } from '../../header'
import { ClassificationContent } from './classification-content'

function getHeaderIcon({
  classificationResults,
  hasSupportedClassification,
  hideClassification,
}: {
  classificationResults?: ClassificationResult[]
  hasSupportedClassification?: boolean
  hideClassification: boolean
}) {
  // If we hide the classification, always show the success icon
  if (hideClassification || hasSupportedClassification) {
    return TwCircleCheck
  }

  // If there are any classification results but none are supported, show the warning icon
  if (classificationResults) {
    return TwQuestionMark
  }

  return TwAlertTriangle
}

type Props = {
  fileName: string
  tempId: string
  fileId?: string
  onDelete?: () => void
}

export function Complete({ fileName, tempId, fileId, onDelete }: Props) {
  const { hideClassification, setSelectedFileToRemove, classificationResults, hasSupportedClassification } =
    useDocumentCardContext()
  const HeaderIcon = getHeaderIcon({ classificationResults, hasSupportedClassification, hideClassification })

  return (
    <>
      <Header
        Icon={HeaderIcon}
        name={fileName}
        onDelete={onDelete}
        setSelectedFileToRemove={() =>
          setSelectedFileToRemove({
            tempId: tempId,
            fileId: fileId,
            fileName: fileName,
            state: FileUploadState.COMPLETED,
          })
        }
      />
      {!hideClassification && (
        <>
          <Divider />
          <ClassificationContent />
        </>
      )}
    </>
  )
}
